export const ACTIVE_BOX_SHADOW = '0px 0px 3px';
export const ACTIVE_BRIGHTNESS = 1.1;
export const VIEW_SCROLLBAR_WIDTH_CSS_VARIABLE = '--view-scrollbar-width';
export const MAIN_GROUP_CONTAINER_CLASSNAME = 'mainGroupContainer';
export const MAIN_GROUP_CONTAINER_SELECTOR = `.${MAIN_GROUP_CONTAINER_CLASSNAME}`;

export const LI_BACKGROUND_CLASS_NAME = 'libackground';
export const NO_FILTER_CLASS_NAME = 'nf';
export const CONDITIONAL_IMAGE_COLORING_CLASS_NAME =
  'accept-conditional-formatting-color';

export const PARENT_CHILD_REFERENCE = 'parent-child-reference';
export const IS_PARENT_OF = 'Is parent of';
export const IS_CHILD_OF = 'Is child of';

export const VIRTUAL_MODEL_ID = 'virtual-model';

export const PARENTS = 'Parents';
export const CHILDREN = 'Children';
export const DEGREES_OF_RELATIONSHIP = 'Degrees of relationship';

export const SHOW_ONLY_CONNECTED_COMPONENTS = 'Show only connected components';
export const INCLUDE_ALL_DESCENDANTS = 'Include all descendants';
export const REFERENCE_ID_ATTRIBUTE = 'data-reference-model-ids';
export const COMPONENT_ID_ATTRIBUTE = 'data-component-id';
export const WORKSPACE_ID_ATTRIBUTE = 'data-workspace-id';
// It so happens that this package contains visualization components.
// To avoid cyclic dependencies we must place these consts here.

export const X_AXIS_CONTAINER_CLASS_NAME = 'visualization-x-axis-container';
export const VISUALIZATION_CONTENT_CONTAINER_CLASS_NAME =
  'visualization-content-container';
export const VISUALIZATION_LEGEND_CONTAINER_CLASS_NAME =
  'visualization-legend-container';
export const EXPORT_AUTOSIZE_CLASS_NAME = 'autoSize';
export const NO_EXPORT_CLASS_NAME = 'noExport';
export const NO_EXPORT_SELECTOR = `.${NO_EXPORT_CLASS_NAME}`;
export const HORIZONTAL_ELLIPSIS = '\u2026';

// In scope diff mode we create two structural identical graphs of the two
// branches we compare by adding the missing entities from the other branch.
// In both sets we use this flag on the entities to indicate if they belong
// to the branch or the one we compare against.
export const DIFF_TYPE = 'diff-type-5115dab9-4a5f-4725-8825-f926452f9f01';
export const DEPENDENCY_MAP_NODES_CONTAINER_PADDING = 16;
export { CommonDropdownOptions } from './enums';

export const DISCOVER_SETTINGS_BAR_STYLE = {
  paddingLeft: '32px',
  paddingRight: '32px',
};

export const GRAPH_ITEM_LABEL_CACHE_SIZE = 500;

export const actionNamespaceComponentHierarchy = 'component-hierarchy';
export const COMPONENT_HIERARCHIES_ID = 'component-hierarchies-root';
export const actionNamespaceSelectComponentHierarchy =
  'select-component-hierarchy';
export const actionNamespaceSelectContext = 'select-context-component';
export const SELECT_COMPONENT_HIERARCHIES_ID =
  'select-component-hierarchies-root';
export const actionNamespaceSelectComponentHierarchyPane =
  'select-component-hierarchy-pane';
export const SELECT_COMPONENT_HIERARCHIES_PANE_ID =
  'select-component-hierarchies-pane-root';
export const actionNamespaceSelectParent = 'select-parent-component-hierarchy';
export const SELECT_PARENT_HIERARCHY_ID =
  'select-parent-component-hierarchy-root';
export const DEFAULT_EMPTY_ITEM_LABELS = {
  mainLabel: null,
  otherLabels: [],
};
export const actionNamespaceComponentOverviewNavigatorPanel =
  'component-overview-navigator-panel';
export const COMPONENT_OVERVIEW_NAVIGATOR_PANEL_ID =
  'component-overview-navigator-panel-root';
export const VOID_REPRESENTATION_DATA = {
  isImage: false,
  value: null,
};
export const anyType = '@@wildcard@@' as const;
export const BACKBONE_MODEL_BATCH_TIMEOUT_MS = 48;
export const mainNavigatorViewpointModeActionNamespace =
  'main-navigator-viewpoint-mode';
